import { render, staticRenderFns } from "./list-customer.vue?vue&type=template&id=704ab68a&scoped=true"
import script from "./list-customer.vue?vue&type=script&lang=js"
export * from "./list-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704ab68a",
  null
  
)

export default component.exports